import {
  ActionMenu,
  ButtonText,
  ItemText,
  Main,
  StyledDropDownButton,
} from 'components/ActionStyles/ActionStyles'
import DownArrow from 'components/icons/DownArrow'
import { reInviteCorporate } from 'modules/Onboarding/Partials/Corporates/Partials/CorporateInfoTable/actions'
import React from 'react'
import { useDispatch } from 'react-redux'
import SuccessMessage from 'utils/SuccessMessage'
const { ADMIN_URL } = process.env

const ActionDropdown = ({
  setVerifyCorporateDrawer,
  rowData,
  setViewCorporateDrawer,
  getSingleCorporateData,
  getSingleUserInfo,
  setAddUserDrawer,
  setUserId,
}) => {
  const dispatch = useDispatch()

  const callBackError = msg => {
    ErrorMessage(msg || 'No Corporate Found')
    navigate('/onboarding')
  }

  const onClickView = () => {
    setViewCorporateDrawer(true)
    dispatch(getSingleCorporateData(rowData?.id, callBackError))
  }

  const onClickVerifyApprove = () => {
    dispatch(getSingleCorporateData(rowData?.id, callBackError))
  }

  const onClickLink = () => {
    navigator.clipboard.writeText(
      `${ADMIN_URL}onboarding/corporate/${rowData?.id}`
    )
    SuccessMessage('Link Coppied!')
  }

  const handleInvite = rowData => {
    dispatch(reInviteCorporate(rowData?.contactEmail))
  }

  const menu = (
    <ActionMenu
      width={'200px'}
      items={[
        {
          key: 'inactive',
          label: (
            <ItemText
              onClick={() => {
                onClickVerifyApprove()
                setVerifyCorporateDrawer(true)
              }}
            >
              {/* Content */}
              Verify & Approve
            </ItemText>
          ),
        },
        {
          key: 'active',
          label: (
            <ItemText onClick={onClickLink}>Copy Onboarding Link</ItemText>
          ),
        },

        {
          key: 'invite',
          label: (
            <ItemText onClick={() => handleInvite(rowData)}>
              Resend Invite
            </ItemText>
          ),
        },
      ]}
    />
  )

  return (
    <Main id="filterDropdown">
      <StyledDropDownButton
        overlay={menu}
        shape="round"
        trigger={['click']}
        icon={<DownArrow />}
        getPopupContainer={() => document.getElementById('filterDropdown')}
      >
        <ButtonText onClick={() => onClickView()}>View</ButtonText>
      </StyledDropDownButton>
    </Main>
  )
}

export default ActionDropdown
